import Marionette from 'backbone.marionette';
import Navigator from 'app';
// for showMembersHome
import MembersHomeLayout from './views/members_home_layout';
import MembersBrowseLayout from './views/members_browse_layout';
import FiltersCompositeview from './views/members_browse_filters_compositeview';
import MembersCollectionview from './views/members_collectionview';
import MapView from './views/map_itemview';
import MembersCollection from '../../entities/member/member_collection';
import FilteredCollection from '../../entities/common/filtered_collection';
import CountyCollection from '../../entities/common/county_collection';
// for showMemberDetail
import MemberDetailLayout from "./views/member_detail_layout";
import MemberDetailItemview from "./views/member_detail_itemview";
import MemberCommitteesCompositview from "./views/member_committees_compositview";
import MemberContributorsCompositview from "./views/member_contributors_compositview";
import MemberVotesCompositview from "./views/member_votes_compositview";
import BillCollectionview from "./views/member_bills_compositeview";
import 'bootstrap'; //so we can access the tabs programatically

export default {
  showMembersHome: function (callback, criterion, homeview) {
    console.log("EMD members_controller showMembersHome criterion: ", criterion, homeview);
    //both of our childviews need to be able to reference the same membersHomeLayout - this allows us to only set it up once regardless of which is loaded first
    if (!homeview) {
      Navigator.vent.trigger("loading:show");
      homeview = new MembersHomeLayout();
      //set up either the map or members browse to show on membersHomeLayout.onShow, depending on current tab/route
      if (callback.name === "showMembersBrowse") {
        //browse tab needs to wait for show so it has a view to load into. Can't do it in showMembersBrowse because if the view already exists (i.e. we switched tabs and back) it will not call show again
        homeview.on("show", function () {
          callback(criterion, homeview);
        });
      } else {
        //map tab already waited for show so we know it's showing and it won't call 'show' again
        callback(criterion, homeview);
      }
      Navigator.mainRegion.show(homeview);
      Navigator.vent.trigger("loading:hide");
    } else {
      callback(criterion, homeview);
    }
  },
  showMembersBrowse: function (criterion, homeview) {
    console.log("EMD members_controller showMembersBrowse criterion: ", criterion, homeview);
    var browseLayout = new MembersBrowseLayout();
    var fetchingMembers = Navigator.request("member:list");
    console.log("fetchingMembers: ", fetchingMembers);
    var fetchingCounties = Navigator.request("counties");
    if (!Navigator.vent._events['members:filter:applied']) {
      Navigator.vent.on("members:filter:applied", function (filter) {
        filter.route = 'members';
        console.log("EMD members:filter:applied", filter);
        Navigator.guest.sendMessage(filter);
      });
    }
    $.when(fetchingMembers, fetchingCounties).done(function (members, counties) {
      counties.add({
        id: "000",
        cntyName: "All"
      }); //adding an 'ALL' choice to the county dropdown
      var filtersCompositeview = new FiltersCompositeview({
        collection: counties
      });
      var filteredMembers = new FilteredCollection({
        collection: members
      });
      window.filteredMembers = filteredMembers;

      // this is true when a button filter is clicked - I wouldn't think we'd need to fetch again but this is firing immediately after the filter is clicked - emd 1.17.25
      if (criterion) {
        filteredMembers.filter(criterion);
        window.filteredMembers = filteredMembers;
        filtersCompositeview.once("show", function () {
          // trigger setFilterCriterion method on FiltersItemview
          filtersCompositeview.triggerMethod("set:filter:criterion", criterion);
        });
      }
      var membersCollectionview = new MembersCollectionview({
        collection: filteredMembers
      });
      if (!Navigator.vent._events['members:by:county']) {
        // triggered when the members_browse county filter dropdown is changed
        // FIXME: doesn't work for counties with space in the name like "Ben Hill" or "Jeff Davis"
        Navigator.vent.on("members:by:county", function (county) {
          console.log("EMD members:by:county", county);
          if (county === "All") {
            membersCollectionview.collection.reset(Navigator.members.models);
          } else {
            var fetchingMembers = Navigator.request("members:county", county);
            $.when(fetchingMembers).done(function (data) {
              membersCollectionview.collection.reset(data.models);
            });
          }
        });
      }
      if (!Navigator.vent._events['members:by:name']) {
        Navigator.vent.on("members:by:name", function (name) {
          if (/[a-zA-Z]/.test(name)) {
            var fetchingMembers = Navigator.request("members:lastname", name);
            $.when(fetchingMembers).done(function (data) {
              membersCollectionview.collection.reset(data.models);
              //membersCollectionview.on("childview:member:detail", function(childView, id) {
              //Navigator.vent.trigger("member:detail", id);
            });
          } else {
            membersCollectionview.collection.reset(Navigator.members.models);
          }
        });
      }
      membersCollectionview.on("childview:member:detail", function (childView, id) {
        Navigator.vent.trigger("member:detail", id);
      });
      browseLayout.on("show", function () {
        browseLayout.membersFiltersRegion.show(filtersCompositeview);
        browseLayout.membersRegion.show(membersCollectionview);
        Navigator.addTips();
      });

      //Navigator.membersHomeLayout.on("show", function() {
      // import(/* webpackChunkName: "map" */'../map/views/map_itemview')
      // .then(module => {
      //   const MapView = module.default
      //   const mapView = new MapView();
      //   membersHomeLayout.membersRegion.show(browseLayout);
      //   Navigator.on("map:show", function() {
      //     membersHomeLayout.mapRegion.show(mapView);
      //   });
      //   // membersHomeLayout.mapRegion.show(mapView);
      // });
      //membersHomeLayout.membersRegion.show(browseLayout);
      // var that = this;
      //         this.onUpdateCb = function() {console.log("MAP UPDATE CALLBACK this: ", that); that.showMap() };

      //Navigator.vent.on("map:show", this.onUpdateCb );

      // this.showMap = function(){
      //   var mapView = new MapView();
      //   membersHomeLayout.showChildView('mapRegion', mapView);
      // }
      homeview.membersRegion.show(browseLayout);
      //membersHomeLayout.mapRegion.show(mapView);
      //});
    }); //$.when(fetchingMembers, fetchingCounties).done(
  },

  activateMapTab: function (unknown, homeview) {
    homeview.on("show", function () {
      //showing the tab will trigger the same event we use when the tab is clicked, so showMembersMap will be triggered in a moment
      $("#map-tab").tab("show");
    });
  },
  showMembersMap: function (empty, homeview) {
    var mapView = new MapView();
    homeview.mapRegion.show(mapView);

    // require([
    //   "./views/members_home_layout",
    //   "./views/map_itemview"
    // ], function(
    //   MembersHomeLayout,
    //   MapView
    // ){

    //Navigator.vent.trigger("loading:show");
    // var membersHomeLayout = new MembersHomeLayout();
    //var mapView = new MapView();
    //membersHomeLayout.on("show", function() {
    //  myregion.show(mapView);
    //})

    //Navigator.vent.trigger("loading:hide");
    //})
  },

  showMemberDetail: function (id) {
    Navigator.vent.trigger("loading:show");
    var memberLayout = new MemberDetailLayout();
    var fetchingMember = Navigator.request("member:detail", id);
    $.when(fetchingMember).done(function (member) {
      window.m = member;
      var views = {};
      console.log("EMD member data: ", member);
      views.detailView = new MemberDetailItemview({
        model: member
      });
      views.contributorsView = new MemberContributorsCompositview({
        collection: member.get("top_contributors")
      });
      views.committeesView = new MemberCommitteesCompositview({
        collection: member.get("member_committees")
      });
      views.votesView = new MemberVotesCompositview({
        collection: member.get("member_votes")
      });
      views.billsView = new BillCollectionview({
        collection: member.get("bills")
      });
      memberLayout.on("show", function () {
        $("#tooltip").hide(); // otherwise the tooltip from the member faces sometimes gets stuck since mouseout isn't triggered
        var regionStrs = ['detail', 'contributors', 'committees', 'bills', 'votes'];
        for (var i = 0; i < regionStrs.length; i++) {
          var regionStr = regionStrs[i];
          // detail is an object and should always have data
          // all the other views are collections - if collection is empty
          // the default region text will show rather than an empty table (visually cleaner)
          if (regionStr === 'detail' || views[regionStr + 'View'].collection.length > 0) {
            console.log("showing " + regionStr + " region");
            memberLayout[regionStr + 'Region']?.show(views[regionStr + 'View']);
          }
        }
      });
      Navigator.vent.trigger("loading:hide");
      Navigator.mainRegion.show(memberLayout);
    }).fail(function (error) {
      console.error(error);
      Navigator.vent.trigger("loading:hide");
      Navigator.vent.trigger("fail");
    }); // $.when(fetchingMember).done()
  }
};